/* eslint-disable react/display-name */
import React, { FC, memo } from "react";

export const SmallDocument: FC = memo(({ ...props }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="40" height="40" rx="8" fill="#A1C7F5" />
    <path
      d="M20.8333 11.6667H14.9999C14.5579 11.6667 14.134 11.8423 13.8214 12.1548C13.5088 12.4674 13.3333 12.8913 13.3333 13.3333V26.6667C13.3333 27.1087 13.5088 27.5326 13.8214 27.8452C14.134 28.1577 14.5579 28.3333 14.9999 28.3333H24.9999C25.4419 28.3333 25.8659 28.1577 26.1784 27.8452C26.491 27.5326 26.6666 27.1087 26.6666 26.6667V17.5M20.8333 11.6667L26.6666 17.5M20.8333 11.6667V17.5H26.6666"
      stroke="#0C458A"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const MediumDocument: FC = memo(({ ...props }) => (
  <svg width="124" height="148" viewBox="0 0 124 148" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="124" height="148" rx="8" fill="#A1C7F5" />
    <path
      d="M63.5 59H53C52.2044 59 51.4413 59.3161 50.8787 59.8787C50.3161 60.4413 50 61.2044 50 62V86C50 86.7956 50.3161 87.5587 50.8787 88.1213C51.4413 88.6839 52.2044 89 53 89H71C71.7956 89 72.5587 88.6839 73.1213 88.1213C73.6839 87.5587 74 86.7956 74 86V69.5M63.5 59L74 69.5M63.5 59V69.5H74"
      stroke="#0C458A"
      strokeWidth="2.505"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const LargeDocument: FC = memo(({ ...props }) => (
  <svg width="144" height="172" viewBox="0 0 144 172" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="144" height="172" rx="8" fill="#A1C7F5" />
    <path
      d="M73.8333 67.6667H60.9999C60.0275 67.6667 59.0948 68.053 58.4072 68.7406C57.7196 69.4282 57.3333 70.3609 57.3333 71.3333V100.667C57.3333 101.639 57.7196 102.572 58.4072 103.259C59.0948 103.947 60.0275 104.333 60.9999 104.333H82.9999C83.9724 104.333 84.905 103.947 85.5926 103.259C86.2803 102.572 86.6666 101.639 86.6666 100.667V80.5M73.8333 67.6667L86.6666 80.5M73.8333 67.6667V80.5H86.6666"
      stroke="#0C458A"
      strokeWidth="3.06167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const SmallImage: FC = memo(({ ...props }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="40" height="40" rx="8" fill="#A1C7F5" />
    <path
      d="M14.1667 27.5H25.8333C26.7538 27.5 27.5 26.7538 27.5 25.8333V14.1667C27.5 13.2462 26.7538 12.5 25.8333 12.5H14.1667C13.2462 12.5 12.5 13.2462 12.5 14.1667V25.8333C12.5 26.7538 13.2462 27.5 14.1667 27.5ZM14.1667 27.5L23.3333 18.3333L27.5 22.5M18.3333 17.0833C18.3333 17.7737 17.7737 18.3333 17.0833 18.3333C16.393 18.3333 15.8333 17.7737 15.8333 17.0833C15.8333 16.393 16.393 15.8333 17.0833 15.8333C17.7737 15.8333 18.3333 16.393 18.3333 17.0833Z"
      stroke="#0C458A"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const MediumImage: FC = memo(({ ...props }) => (
  <svg width="124" height="148" viewBox="0 0 124 148" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="124" height="148" rx="8" fill="#A1C7F5" />
    <path
      d="M51.5 87.5H72.5C74.1569 87.5 75.5 86.1569 75.5 84.5V63.5C75.5 61.8431 74.1569 60.5 72.5 60.5H51.5C49.8431 60.5 48.5 61.8431 48.5 63.5V84.5C48.5 86.1569 49.8431 87.5 51.5 87.5ZM51.5 87.5L68 71L75.5 78.5M59 68.75C59 69.9926 57.9926 71 56.75 71C55.5074 71 54.5 69.9926 54.5 68.75C54.5 67.5074 55.5074 66.5 56.75 66.5C57.9926 66.5 59 67.5074 59 68.75Z"
      stroke="#0C458A"
      strokeWidth="2.505"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const LargeImage: FC = memo(({ ...props }) => (
  <svg width="144" height="172" viewBox="0 0 144 172" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="144" height="172" rx="8" fill="#A1C7F5" />
    <path
      d="M59.1667 102.5H84.8333C86.8584 102.5 88.5 100.858 88.5 98.8333V73.1667C88.5 71.1416 86.8584 69.5 84.8333 69.5H59.1667C57.1416 69.5 55.5 71.1416 55.5 73.1667V98.8333C55.5 100.858 57.1416 102.5 59.1667 102.5ZM59.1667 102.5L79.3333 82.3333L88.5 91.5M68.3333 79.5833C68.3333 81.1021 67.1021 82.3333 65.5833 82.3333C64.0646 82.3333 62.8333 81.1021 62.8333 79.5833C62.8333 78.0646 64.0646 76.8333 65.5833 76.8333C67.1021 76.8333 68.3333 78.0646 68.3333 79.5833Z"
      stroke="#0C458A"
      strokeWidth="3.06167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const SmallVideo: FC = memo(({ ...props }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="40" height="40" rx="8" fill="#A1C7F5" />
    <path d="M14.1667 12.5L25.8334 20L14.1667 27.5V12.5Z" stroke="#0C458A" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const MediumVideo: FC = memo(({ ...props }) => (
  <svg width="124" height="148" viewBox="0 0 124 148" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="124" height="148" rx="8" fill="#A1C7F5" />
    <path d="M51.5 60.5L72.5 74L51.5 87.5V60.5Z" stroke="#0C458A" strokeWidth="2.505" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const LargeVideo: FC = memo(({ ...props }) => (
  <svg width="144" height="172" viewBox="0 0 144 172" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="144" height="172" rx="8" fill="#A1C7F5" />
    <path d="M59.1667 69.5L84.8334 86L59.1667 102.5V69.5Z" stroke="#0C458A" strokeWidth="3.06167" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const SmallAudio: FC = memo(({ ...props }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="40" height="40" rx="8" fill="#A1C7F5" />
    <path
      d="M17.5 25V14.1667L27.5 12.5V23.3333M17.5 25C17.5 26.3807 16.3807 27.5 15 27.5C13.6193 27.5 12.5 26.3807 12.5 25C12.5 23.6193 13.6193 22.5 15 22.5C16.3807 22.5 17.5 23.6193 17.5 25ZM27.5 23.3333C27.5 24.714 26.3807 25.8333 25 25.8333C23.6193 25.8333 22.5 24.714 22.5 23.3333C22.5 21.9526 23.6193 20.8333 25 20.8333C26.3807 20.8333 27.5 21.9526 27.5 23.3333Z"
      stroke="#0C458A"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const MediumAudio: FC = memo(({ ...props }) => (
  <svg width="124" height="148" viewBox="0 0 124 148" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="124" height="148" rx="8" fill="#A1C7F5" />
    <path
      d="M57.5 83V63.5L75.5 60.5V80M57.5 83C57.5 85.4853 55.4853 87.5 53 87.5C50.5147 87.5 48.5 85.4853 48.5 83C48.5 80.5147 50.5147 78.5 53 78.5C55.4853 78.5 57.5 80.5147 57.5 83ZM75.5 80C75.5 82.4853 73.4853 84.5 71 84.5C68.5147 84.5 66.5 82.4853 66.5 80C66.5 77.5147 68.5147 75.5 71 75.5C73.4853 75.5 75.5 77.5147 75.5 80Z"
      stroke="#0C458A"
      strokeWidth="2.505"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const LargeAudio: FC = memo(({ ...props }) => (
  <svg width="144" height="172" viewBox="0 0 144 172" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="144" height="172" rx="8" fill="#A1C7F5" />
    <path
      d="M66.5 97V73.1667L88.5 69.5V93.3333M66.5 97C66.5 100.038 64.0376 102.5 61 102.5C57.9624 102.5 55.5 100.038 55.5 97C55.5 93.9624 57.9624 91.5 61 91.5C64.0376 91.5 66.5 93.9624 66.5 97ZM88.5 93.3333C88.5 96.3709 86.0376 98.8333 83 98.8333C79.9624 98.8333 77.5 96.3709 77.5 93.3333C77.5 90.2958 79.9624 87.8333 83 87.8333C86.0376 87.8333 88.5 90.2958 88.5 93.3333Z"
      stroke="#0C458A"
      strokeWidth="3.06167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const SmallNotFound: FC = memo(({ ...props }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="40" height="40" rx="8" fill="#D0D5DD" />
    <path
      d="M20.8333 11.6667H14.9999C14.5579 11.6667 14.134 11.8423 13.8214 12.1548C13.5088 12.4674 13.3333 12.8913 13.3333 13.3333V26.6667C13.3333 27.1087 13.5088 27.5326 13.8214 27.8452C14.134 28.1577 14.5579 28.3333 14.9999 28.3333H24.9999C25.4419 28.3333 25.8659 28.1577 26.1784 27.8452C26.491 27.5326 26.6666 27.1087 26.6666 26.6667V17.5M20.8333 11.6667L26.6666 17.5M20.8333 11.6667V17.5H26.6666M22.2223 20.2778L20.0001 22.5M20.0001 22.5L17.7778 24.7223M20.0001 22.5L17.7778 20.2778M20.0001 22.5L22.2223 24.7223"
      stroke="#344054"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const MediumNotFound: FC = memo(({ ...props }) => (
  <svg width="124" height="148" viewBox="0 0 124 148" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="124" height="148" rx="8" fill="#D0D5DD" />
    <path
      d="M63.4999 59H52.9999C52.2042 59 51.4412 59.3161 50.8786 59.8787C50.3159 60.4413 49.9999 61.2044 49.9999 62V86C49.9999 86.7957 50.3159 87.5587 50.8786 88.1213C51.4412 88.6839 52.2042 89 52.9999 89H70.9999C71.7955 89 72.5586 88.6839 73.1212 88.1213C73.6838 87.5587 73.9999 86.7957 73.9999 86V69.5M63.4999 59L73.9999 69.5M63.4999 59V69.5H73.9999M66.0001 74.5001L62.0001 78.5001M62.0001 78.5001L58.0001 82.5001M62.0001 78.5001L58.0001 74.5001M62.0001 78.5001L66.0001 82.5001"
      stroke="#344054"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const LargeNotFound: FC = memo(({ ...props }) => (
  <svg width="144" height="172" viewBox="0 0 144 172" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="144" height="172" rx="8" fill="#D0D5DD" />
    <path
      d="M73.8333 67.6667H60.9999C60.0275 67.6667 59.0948 68.053 58.4072 68.7406C57.7196 69.4282 57.3333 70.3609 57.3333 71.3333V100.667C57.3333 101.639 57.7196 102.572 58.4072 103.259C59.0948 103.947 60.0275 104.333 60.9999 104.333H82.9999C83.9724 104.333 84.905 103.947 85.5926 103.259C86.2803 102.572 86.6666 101.639 86.6666 100.667V80.5M73.8333 67.6667L86.6666 80.5M73.8333 67.6667V80.5H86.6666M76.8891 86.6112L72.0002 91.5001M72.0002 91.5001L67.1113 96.389M72.0002 91.5001L67.1113 86.6112M72.0002 91.5001L76.8891 96.389"
      stroke="#344054"
      strokeWidth="3.06"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
